import { Component, Input } from '@angular/core';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { GetSupplierBasicInformationResponse } from '@lsq-frontend/remote-services/all-java/financing-mk2-services/buyer-account/supplier-details/get-supplier-basic-information';

@Component({
    selector: 'supplier-basic-information',
    template: `
        <card [headerTitle]="headerTitle">
            <div card-body [style.minHeight]="'20.5rem'">
                <lsq-circle-loader *ngIf="!basicInformation"></lsq-circle-loader>
                <div *ngIf="!!basicInformation" [style.padding]="'3rem 4rem 0 4rem'">
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="nameLabel" i18n>Name</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="name">
                                <lsq-smart-truncate
                                    [value]="!basicInformation.name ? '—' : basicInformation.name"
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="supplierIdLabel" i18n>Supplier ID</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="supplierId">
                                <lsq-smart-truncate
                                    [value]="
                                        !basicInformation.supplierId
                                            ? '—'
                                            : basicInformation.supplierId
                                    "
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="taxIdLabel" i18n>Tax ID</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="taxID">
                                <lsq-smart-truncate
                                    [value]="!basicInformation.taxID ? '—' : basicInformation.taxID"
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="countryLabel" i18n>Country/Region</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="country">
                                <lsq-smart-truncate
                                    [value]="
                                        !basicInformation.country ? '—' : basicInformation.country
                                    "
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="address" i18n>Address</span>
                            </p>
                            <div [style.paddingTop]="'0.5rem'" id="address">
                                <div id="firstLine" class="p body">
                                    <lsq-smart-truncate
                                        [value]="
                                            !basicInformation.address
                                                ? '—'
                                                : basicInformation.address
                                        "
                                    ></lsq-smart-truncate>
                                </div>
                                <div id="secondLine" class="p body">
                                    <lsq-smart-truncate
                                        [value]="basicInformation.addressLine2"
                                    ></lsq-smart-truncate>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="cityLabel" i18n>City/Locality</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="city">
                                <lsq-smart-truncate
                                    [value]="
                                        !basicInformation.addressCity
                                            ? '—'
                                            : basicInformation.addressCity
                                    "
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="stateLabel" i18n>State/Province</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="state">
                                <lsq-smart-truncate
                                    [value]="
                                        !basicInformation.addressState
                                            ? '—'
                                            : basicInformation.addressState
                                    "
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-3" [style.marginBottom]="'3rem'">
                            <p class="data-label">
                                <span id="postalCodeLabel" i18n>Postal code</span>
                            </p>
                            <div class="p body" [style.paddingTop]="'0.5rem'" id="postalCode">
                                <lsq-smart-truncate
                                    [value]="
                                        !basicInformation.addressPostalCode
                                            ? '—'
                                            : basicInformation.addressPostalCode
                                    "
                                ></lsq-smart-truncate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>
    `,
    styleUrls: ['./supplier-basic-information.component.scss']
})
export class SupplierBasicInformationComponent {
    @Input() public basicInformation: GetSupplierBasicInformationResponse | null = null;

    public headerTitle = this._i18n('Basic Information');

    constructor(private _i18n: I18n) {}
}
